// AI Generated
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-no-index',
    standalone: false,
    template: `
        <h5 translate>This page has been marked as no index</h5>
    `,
})
export class SeoInformationNoIndexComponent {
    @Input() seo: any;
}
